import * as types from "./mutation-types";
import userParser from "./utils/userParser";

const token = localStorage.getItem(types.TOKEN);
const user = userParser(token);
export default {
  token,
  user,
};
